import React, { useContext, useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import { CommonContext } from '../../../../context';
import { useLocation } from 'react-router-dom';
import OrderStatusTable from './OrderStatusTable';

const OrderStatus = () => {
    const { user, onMerchantCourier } = useContext(CommonContext)

    let location = useLocation();

    useEffect(() => {
        onMerchantCourier();
    }, [])
    return (
        <>
            <OrderStatusTable />
        </>
    );
};

export default OrderStatus;
